export function assertUnreachable(n: never): never {
  console.error(`Didn't expect to get here. Was passed "${n as string}"`);
  return n;
}
